import React from "react";
import ProjectList from "../components/Apps/Wingspan/projectList/ProjectList";
import { CssBaseline } from "@mui/material";
import { useNavigate } from "react-router-dom";

const Wingspan = () => {
  const navigate = useNavigate();

  return (
    <div>
      <ProjectList navigate={navigate} />
    </div>
  );
};

export default Wingspan;
